// extracted by mini-css-extract-plugin
export default {"customPlaceholderWrapper":"styles_customPlaceholderWrapper__67uYw","redAsteriks":"styles_redAsteriks__+ykoG"};